import { useEffect, useState } from "react";
import { useMainContext } from "../../../Context";
import { storeContactUs, Contact_us } from "../../../Utils/Apis";

export const useContact = () => {
  const [form, setForm] = useState({});
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [btnloading, setBtnLoading] = useState(false);
  const { post } = useMainContext();
  const send = async () => {
    setLoading(true);
    await post(storeContactUs, form, true);
    setLoading(false);
  };
  const handler = (key, value) => {
    setForm({ ...form, [key]: value });
  };
  const getData = async () => {
    setLoading(true);
    const { data, status } = await post(Contact_us);
    if (+status == 200) {
      setData(data);
      setLoading(false);
    }
  };
  useEffect(() => {
    getData();
  }, []);
  return {
    data,
    loading,
    send,
    form,
    setForm,
    btnloading,
    handler,
  };
};
